<template>
    <div>
      <div class="container fluid" v-if="user.authenticated">
        <div class="row" v-if="this.messageresult">
          <div class="col">
          <h1>Your payoff has been requested</h1>
          <p>Thank you for requesting a payoff quote for Lease # {{parentData}}. If this is a discounted deal, please contact your broker to receive your payoff quote.
          </p>
          <p>Your RFQ will be sent to your email address</p>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col">
            <h1>There was an issue sending your payoff quote request please try again later</h1>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col text-center">
          <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
        </div>
      </div>
    </div>
</template>

<script>
import auth from './auth'
export default {
  name: 'modalRequestPayOff',
  components: {
  },
  props: {
    parentData: {
      type: Number
    },
    messageresult: {
      type: Boolean
    }
  },
  methods: {
  },
  data: function () {
    return {
      user: auth.user
    }
  },
  created: function () {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modalRequestPayoff.vue